var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompass48Filled = function SvgIconCompass48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 7.3a16.7 16.7 0 1 0 16.7 16.7 16.72 16.72 0 0 0-16.7-16.7Zm8.91 11.46-2.7 8.09a5.319 5.319 0 0 1-3.35 3.35l-8.09 2.7a2.9 2.9 0 0 1-3.67-3.67l2.69-8.09a5.351 5.351 0 0 1 3.36-3.35l8.09-2.69a2.849 2.849 0 0 1 3 .69 2.89 2.89 0 0 1 .67 2.97Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.999 25.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z",
    fill: "current"
  })));
};
export default SvgIconCompass48Filled;